import { render, staticRenderFns } from "./addMainCategoryProduct.vue?vue&type=template&id=ab064848&scoped=true"
import script from "./addMainCategoryProduct.vue?vue&type=script&lang=js"
export * from "./addMainCategoryProduct.vue?vue&type=script&lang=js"
import style0 from "./addMainCategoryProduct.vue?vue&type=style&index=0&id=ab064848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab064848",
  null
  
)

export default component.exports